import {Injectable} from '@angular/core';
import {AppService} from '../../../core/services/app.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    searchUrl = AppService.getApiUrl() + '/api/search/tags';

    constructor(private http: HttpClient) {
    }

    searchPhotosByTag(tag) {
        const url = `${this.searchUrl}/${tag}`;
        return this.http.get(url);
    }
}
